import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LEGACY_PAYMENTS_ROUTES = {
  'brand.apps.payments.disputes': 'brand.billing.disputes',
  'brand.apps.payments.gift-cards': 'brand.gift-cards',
  'brand.apps.payments.payouts': 'brand.billing.payouts',
  'brand.apps.payments.transactions': 'brand.billing.transactions',
} as const

export const checkHestiaPaymentsFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !(to.name in LEGACY_PAYMENTS_ROUTES)) {
    return undefined
  }

  if (useFeatureFlags().isEnabled('hermes.hestiaPayments')) {
    return undefined
  }

  return {
    name: LEGACY_PAYMENTS_ROUTES[
      to.name as keyof typeof LEGACY_PAYMENTS_ROUTES
    ],
    params: { brandId: to.params.brandId },
  }
}
